import type { AtualizarContaContabilDto, AtualizarItemCifDto, ContaContabilResponse, CriarContaContabilDto, CriarItemCifDto, ItemCifResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Itens de CIF recorrentes (GET /itens-cif): `rateio.ver`. Lista sem paginacao na tela (limit maximo 200). */
export function useItensCif(q: { q?: string; ativo?: boolean; limit?: number } = {}) {
  return useConsulta<ItemCifResponse[]>(['itens-cif'], '/itens-cif', { query: { ...q, ativo: q.ativo === undefined ? undefined : String(q.ativo) } });
}

/** Criacao (POST /itens-cif): `rateio.editar`. Invalida itens. */
export function useCriarItemCif() {
  return useMutacao<ItemCifResponse, CriarItemCifDto>({
    metodo: 'POST',
    caminho: () => '/itens-cif',
    corpo: (v) => v,
    invalidar: [['itens-cif']],
  });
}

/** Alteracao (PATCH /itens-cif/:id): `rateio.editar`. */
export function useAtualizarItemCif() {
  return useMutacao<ItemCifResponse, { id: string; dto: AtualizarItemCifDto }>({
    metodo: 'PATCH',
    caminho: (v) => `/itens-cif/${v.id}`,
    corpo: (v) => v.dto,
    invalidar: [['itens-cif']],
  });
}

/** Contas contabeis (GET /contas-contabeis): `rateio.ver`. */
export function useContasContabeis(q: { q?: string; ativo?: boolean; limit?: number } = {}) {
  return useConsulta<ContaContabilResponse[]>(['contas-contabeis'], '/contas-contabeis', { query: { ...q, ativo: q.ativo === undefined ? undefined : String(q.ativo) } });
}

/** Criacao (POST /contas-contabeis): `rateio.editar`. Invalida contas e itens (nomes das contas). */
export function useCriarContaContabil() {
  return useMutacao<ContaContabilResponse, CriarContaContabilDto>({
    metodo: 'POST',
    caminho: () => '/contas-contabeis',
    corpo: (v) => v,
    invalidar: [['contas-contabeis'], ['itens-cif']],
  });
}

/** Alteracao (PATCH /contas-contabeis/:id): `rateio.editar`. */
export function useAtualizarContaContabil() {
  return useMutacao<ContaContabilResponse, { id: string; dto: AtualizarContaContabilDto }>({
    metodo: 'PATCH',
    caminho: (v) => `/contas-contabeis/${v.id}`,
    corpo: (v) => v.dto,
    invalidar: [['contas-contabeis'], ['itens-cif']],
  });
}

/** Exclusao (DELETE /contas-contabeis/:id): `rateio.editar`. 409 CONTA_EM_USO quando a conta ja foi usada (a tela mostra a mensagem da API). Invalida contas e itens. */
export function useExcluirContaContabil() {
  return useMutacao<void, string>({
    metodo: 'DELETE',
    caminho: (id) => `/contas-contabeis/${id}`,
    invalidar: [['contas-contabeis'], ['itens-cif']],
  });
}
